import { defineComponent as _defineComponent } from 'vue'
import {
  TransactionReason as TransactionReasonEnum,
  TransactionExternal,
  transactionReasonLabels,
  HistoricalTransaction,
} from 'ah-api-gateways';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionReason',
  props: {
    transaction: null
  },
  setup(__props: any) {

const props = __props as {
  transaction: HistoricalTransaction;
};



const transactionReasonText = computed(() => {
  if (props.transaction.reason === TransactionReasonEnum.DEPOSIT_FROM_UNKNOWN) {
    let out = 'Deposit';
    const extTransaction = props.transaction as TransactionExternal;
    if (extTransaction.otherName) {
      out += ` from ${extTransaction.otherName}`;
    }
    return out;
  }

  return transactionReasonLabels[props.transaction.reason];
});

return { __sfc: true,props, transactionReasonText }
}

})